export default __webpack_public_path__ + "static/media/blog-paver-walkway-006.b44c3f9a.jpg";